import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoHospitalizacion({ idSolicitud, onCreate }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [servicio, setServicio] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");

  const limpiarFormulario = () => {
    setNombre("");
    setServicio("");
    setCargo("");
    setLider("");
  };

  const postData = async (e) => {
    e.preventDefault();

    try {
      const res = await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoHospitalizacion",
        data: {
          nombre,
          servicio,
          cargo,
          lider,
          SolicitudId: idSolicitud,
        },
      });

      // 🔥 CONSTRUIMOS EL OBJETO COMPLETO
      const nuevoRegistro = {
        id: res.data.id, // ← ID devuelto por el backend
        nombre,
        servicio,
        cargo,
        lider,
      };

      onCreate(nuevoRegistro);
      limpiarFormulario();
      setIsOpen(false);
    } catch (error) {
      console.error(error);
      alert("Error al crear el equipo");
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Crear EQUIPO PRIMARIO DE MEJORAMIENTO DE HOSPITALIZACIÓN
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <input
                className="form-control mb-2"
                placeholder="Nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                required
              />

              <input
                className="form-control mb-2"
                placeholder="Servicio"
                value={servicio}
                onChange={(e) => setServicio(e.target.value)}
                required
              />

              <input
                className="form-control mb-2"
                placeholder="Cargo"
                value={cargo}
                onChange={(e) => setCargo(e.target.value)}
                required
              />

              <select
                className="form-control mb-3"
                value={lider}
                onChange={(e) => setLider(e.target.value)}
                required
              >
                <option value="">¿Es líder?</option>
                <option value="Si">Sí</option>
                <option value="No">No</option>
              </select>

              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setIsOpen(false)}
                >
                  Cancelar
                </button>

                <button type="submit" className="btn btn-primary">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaEquipoHospitalizacion;
